'use client';

import Link from 'next/link';
import { ArrowUpRight, Building2, CheckCircle2, Clock3, Sparkles } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { dashboardToneClasses, formatDashboardNumber } from './analytics-dashboard-style';
import type { AnalyticsHubKpi } from './analytics-dashboard-types';

const ICONS = {
  locations: Building2,
  opened: CheckCircle2,
  open_now: Clock3,
  attention: Sparkles,
};

interface DashboardKpiStripProps {
  items: AnalyticsHubKpi[];
}

export function DashboardKpiStrip({ items }: DashboardKpiStripProps) {
  return (
    <div className="grid grid-cols-2 gap-2.5 sm:gap-3 lg:grid-cols-4">
      {items.map((item) => {
        const Icon = ICONS[item.key as keyof typeof ICONS] || Sparkles;
        const tone = dashboardToneClasses(item.tone);

        return (
          <Link key={item.key} href={item.href} className="block min-w-0">
            <Card className={`h-full rounded-3xl border bg-[var(--app-surface)] shadow-sm transition hover:-translate-y-0.5 hover:shadow-md ${tone.border}`}>
              <CardContent className="p-3 sm:p-4">
                <div className="flex items-start justify-between gap-2">
                  <span className={`rounded-2xl p-2 ${tone.soft}`}>
                    <Icon className="h-4 w-4" />
                  </span>
                  <ArrowUpRight className="h-4 w-4 text-[var(--app-text-muted)]" />
                </div>
                <p className="mt-3 text-[11px] font-semibold uppercase tracking-wide text-[var(--app-text-soft)]">{item.title}</p>
                <p className="mt-1 text-2xl font-black tabular-nums text-[var(--app-text)] sm:text-3xl">{formatDashboardNumber(item.value)}</p>
                <p className="mt-1 line-clamp-2 text-xs leading-snug text-[var(--app-text-muted)]">{item.hint}</p>
              </CardContent>
            </Card>
          </Link>
        );
      })}
    </div>
  );
}

